/**
 * Quick View Modal
 * Handles the quick view modal functionality for product cards
 */

function quickView(handle, event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const modal_quickView = document.getElementById('modal_quickView');
  const data_modal_img1_quickView = document.querySelector('[data-modal-img1-quickView]');
  const data_modal_img2_quickView = document.querySelector('[data-modal-img2-quickView]');
  const modal_body_info_quickView = document.querySelector('[data-modal-body-quickView]');
  const modal_bg = document.getElementById('modal_bg');
  const modal_qv_close = document.getElementById('btn_close_quickView');

  // Mostrar modal y fondo
  modal_bg.classList.add('show-modal');
  modal_quickView.classList.add('show-modal');

  // Limpiar contenido previo y mostrar loading
  data_modal_img1_quickView.innerHTML = '';
  data_modal_img2_quickView.innerHTML = '';
  modal_body_info_quickView.innerHTML = `
    <div class="loading-quickview">
      <div class="loading-spinner"></div>
      <p>Cargando producto...</p>
    </div>
  `;

  async function getQuickProduct() {
    try {
      const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`);

      if (!response.ok) {
        throw new Error('Error al obtener el producto. Estado HTTP: ' + response.status);
      }

      const data = await response.json();

      // Renderizar imágenes
      for (let index = 0; index < data.images.length; index++) {
        const element = data.images[index];
        const swiper_main = `
          <div class="swiper-slide">
            <img class="swiper-slide_img"
                  src="${element}"
                  loading="lazy"
                  alt="${data.title}"
                  width="400px"
                  height="400px" />
          </div>
        `;
        data_modal_img1_quickView.innerHTML += swiper_main;
        data_modal_img2_quickView.innerHTML += swiper_main;
      }

      // Inicializar Swiper después de que las imágenes estén en el DOM
      if (window.Swiper) {
        const swiper_img_thumb = new Swiper(".modal_swiper_thumbs", {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
        });

        const swiper_img_main = new Swiper(".modal_swiper_main", {
          spaceBetween: 10,
          navigation: {
            nextEl: ".modal_swiper_main .swiper-button-next",
            prevEl: ".modal_swiper_main .swiper-button-prev",
          },
          thumbs: {
            swiper: swiper_img_thumb,
          },
        });
      }

      // Buscar tag de modelo
      const modeloTag = data.tags.find(tag => tag.toLowerCase().includes("modelo"));
      let modeloValue = '';
      if (modeloTag) {
        modeloValue = modeloTag.split("_")[1] || modeloTag;
      }

      // Formatear precio
      const price = data.price;
      const price_Formateado = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN'
      }).format(price / 100);

      let priceHTML = '';
      if (data.compare_at_price && data.compare_at_price > price) {
        const compareAtPrice_Formateado = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN'
        }).format(data.compare_at_price / 100);

        priceHTML = `
          <div class="price price--large price--on-sale">
            <div class="price__container">
              <div class="price__sale">
                <s class="price-item price-item--regular">
                  ${compareAtPrice_Formateado}
                </s>
                <span class="price-item price-item--sale">
                  ${price_Formateado}
                </span>
              </div>
            </div>
          </div>
        `;
      } else {
        priceHTML = `
          <div class="price price--large">
            <div class="price__container">
              <span class="price-item price-item--regular">
                ${price_Formateado}
              </span>
            </div>
          </div>
        `;
      }

      // Construir contenido del modal
      const modal_body_quickView = `
        <div class="product-quickview__content">
          ${data.vendor ? `
            <div class="product-quickview__vendor">
              <a href="/collections/vendors?q=${data.vendor}">
                Marca: ${data.vendor}
              </a>
            </div>
          ` : ''}

          <h2 class="product-quickview__title">${data.title}</h2>

          ${modeloValue ? `
            <div class="product-quickview__vendor">
              <strong>Modelo:</strong> ${modeloValue}
            </div>
          ` : ''}

          ${data.variants[0]?.sku ? `
            <p class="product-quickview__sku">
              SKU: ${data.variants[0].sku}
            </p>
          ` : ''}

          <div class="product-quickview__price">
            ${priceHTML}
          </div>

          <a href="${data.url}" class="product-quickview__link">
            Ver Producto Completo
          </a>

          ${data.description ? `
            <div class="product-quickview__description">
              ${data.description}
            </div>
          ` : ''}
        </div>
      `;

      modal_body_info_quickView.innerHTML = modal_body_quickView;

    } catch (error) {
      console.error('Ocurrió un error al obtener el producto:', error);
      modal_body_info_quickView.innerHTML = `
        <div class="product-quickview__error">
          <p>Error al cargar el producto. Por favor, intenta de nuevo.</p>
        </div>
      `;
    }
  }

  getQuickProduct();

  // Función para cerrar modal
  function closeModal() {
    modal_bg.classList.remove('show-modal');
    modal_quickView.classList.remove('show-modal');

    // Limpiar después de la animación
    setTimeout(() => {
      data_modal_img1_quickView.innerHTML = '';
      data_modal_img2_quickView.innerHTML = '';
      modal_body_info_quickView.innerHTML = '';
    }, 300);
  }

  // Event listeners
  modal_bg.addEventListener('click', closeModal, { once: true });
  modal_qv_close.addEventListener('click', closeModal, { once: true });
}

// Exponer función globalmente
window.quickView = quickView;
